<template>
  <div
    class="custom-list-event-row pt-4 pb-6 justify-center d-none d-md-flex"
    :class="{ 'custom-list-event-row--last': isLast }"
    @click="$emit('event-click', event)"
  >
    <div class="custom-list-event-indicator d-flex" :style="{ backgroundColor }"></div>

    <div class="custom-list-event-thumbnail">
      <v-img v-if="thumbnailSrc" :src="thumbnailSrc" contain class="rounded-lg" />
      <div v-else class="custom-list-event-thumbnail-placeholder rounded-lg d-flex align-center justify-center">
        <v-icon color="plusGreyLighten2" size="32">mdi-calendar-blank</v-icon>
      </div>
    </div>

    <div class="d-flex flex-column flex-grow-1">
      <div class="font-weight-bold text-subtitle-1 plusIndigoDarken1--text">
        {{ title }}
      </div>

      <v-row class="d-flex flex-row">
        <v-col cols="4" class="d-flex">
          <div>
            <div>
              <v-icon size="18" color="plusGreyDarken1">mdi-calendar-month-outline</v-icon>
              <span class="text-subtitle-2 ml-2 font-weight-regular">{{ dateText }}</span>
            </div>
            <div>
              <v-icon size="18" color="plusGreyDarken1">mdi-clock-outline</v-icon>
              <span class="text-subtitle-2 ml-2 font-weight-regular">{{ timeText }}</span>
            </div>
          </div>
        </v-col>

        <v-col cols="4" class="d-flex">
          <div class="d-flex flex-column pl-2" style="border-left: 1px solid #E0E0E0; gap: 4px;">
            <div>
              <v-icon size="18" color="plusGreyDarken1">mdi-karate</v-icon>
              <span class="text-subtitle-2 ml-2 font-weight-regular">{{ instructorLine }}</span>
            </div>
            <div>
              <v-icon size="18" color="plusGreyDarken1">mdi-currency-usd-off</v-icon>
              <span class="text-subtitle-2 ml-2 font-weight-regular">{{ pricingLabel }}</span>
            </div>
          </div>
        </v-col>

        <v-col cols="4" class="d-flex">
          <div class="d-flex flex-column pl-2" style="border-left: 1px solid #E0E0E0; gap: 4px;">
            <div>
              <v-icon size="18" color="plusGreyDarken1">mdi-account-multiple-outline</v-icon>
              <span class="text-subtitle-2 ml-2 font-weight-regular">{{ participantsText }}</span>
            </div>
            <div>
              <v-icon size="18" color="plusGreyDarken1">mdi-emoticon-plus-outline</v-icon>
              <span class="text-subtitle-2 ml-2 font-weight-regular">{{ membershipLabel }}</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarListEventRow',
  props: {
    event: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    },
    thumbnailSrc: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    dateText: {
      type: String,
      default: ''
    },
    timeText: {
      type: String,
      default: ''
    },
    instructorLine: {
      type: String,
      default: ''
    },
    pricingLabel: {
      type: String,
      default: ''
    },
    participantsText: {
      type: String,
      default: ''
    },
    membershipLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['event-click']
};
</script>

<style lang="scss" scoped>
.custom-list-event-row {
  align-items: stretch;
  gap: 16px;
  cursor: pointer;
  transition: background-color 0.15s;
  border-bottom: 1px solid #E0E0E0;
}

.custom-list-event-row:hover {
  background-color: #FAFAFA;
}

.custom-list-event-row--last {
  border-bottom: none;
}

.custom-list-event-indicator {
  width: 6px;
  min-width: 6px;
  border-radius: 3px;
  flex-shrink: 0;
}

.custom-list-event-thumbnail {
  width: 76px;
  min-width: 76px;
  height: 76px;
  flex-shrink: 0;
}

.custom-list-event-thumbnail-placeholder {
  width: 100%;
  height: 100%;
  background: #F5F5F5;
}

.custom-list-event-thumbnail .v-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
